import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { noop } from 'Helpers/PropTypes';
import Relationship from 'facet-rest/src/domain/Relationship';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

export const TalkToSupport = ({
  description,
  relationship,
  onClick,
}) => {
  const isMobile = useMobileLayout();
  const button = (
    <FDSecondaryActionButton
      size="sm"
      label={relationship.meta('prompt')}
      onClick={onClick}
    />
  );
  if (!description) {
    return <FDStack justifyContent="center">{button}</FDStack>;
  }
  return (
    <BorderedTransparentBox padding={isMobile ? 2 : 3}>
      <FDStack justifyContent="space-between" alignItems="center" wrap spacing={isMobile ? 1 : 0}>
        <FDBodyText value={description} />
        {button}
      </FDStack>
    </BorderedTransparentBox>
  );
};

TalkToSupport.defaultProps = {
  onClick: noop,
  description: '',
};

TalkToSupport.propTypes = {
  description: PropTypes.string,
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  onClick: PropTypes.func,
};
